/*
==========================================================
CLIENT STATUS OPTIONS
==========================================================
*/

export const CLIENT_STATUS = [

  {
    value: "",
    label: "Todos"
  },

  {
    value: "active",
    label: "Activo"
  },

  {
    value: "inactive",
    label: "Inactivo"
  }

];